import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import type { FrozenMessage } from '@module/types/centrifuge/public-message/freezeMessageTypes';
interface Props {
  fontSizeClass?: string;
  item: FrozenMessage;
}
export default function FrozenChat(props) {
  const $ = _c(7);
  const {
    fontSizeClass,
    item
  } = props;
  const {
    message
  } = item.data;
  let t0;
  if ($[0] !== fontSizeClass) {
    t0 = cn("mb-[3px] whitespace-pre-wrap text-cht_al_1", fontSizeClass);
    $[0] = fontSizeClass;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== message) {
    t1 = <div>{message}</div>;
    $[2] = message;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className={t0}>{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}